import { faHandshake, faPills } from '@fortawesome/free-solid-svg-icons';
import {
  faThumbsUp
} from '@fortawesome/free-regular-svg-icons'
import { ColorEnum } from 'enum'
import { WidgetInterface } from 'interfaces'
import routes from 'routes'

const { 
  desktop,
  jobSearchList,
  prescriptionList,
  transferWithFavorites,
  supplyList,
  packsList,
  drugFavoriteList,
} = routes

const dashboardWidgets: WidgetInterface[] = [
  {
    name: "Exchange",
    icon: faHandshake,
    backColor: ColorEnum._green,
    color: ColorEnum.White,
    to: `${desktop}?state=waiting`,
    description: 'مشاهده درخواست‌های تبادل با لیست شما',
  },
  // {
  //   name: "insertProduct",
  //   icon: faCapsules,
  //   backColor: ColorEnum._blue,
  //   color: ColorEnum.White,
  //   to: supplyList,
  //   description: 'محصولات جدید خود را ثبت و محصولات قبلی خود را در صورت نیاز ویرایش کنید.',
  // },
  // {
  //   name: "insertFavorite",
  //   icon: faStar,
  //   backColor: ColorEnum._yellow,
  //   color: ColorEnum.White,
  //   to: drugFavoriteList,
  //   description: 'محصولات مصرفی و مورد نیاز خود را در این قسمت ثبت کنید تا سامانه بر این اساس به شما پیشنهاد دهد.',
  // },
  // {
  //   name: "insertPack",
  //   icon: faBoxOpen,
  //   backColor: ColorEnum._yellow,
  //   color: ColorEnum.White,
  //   to: packsList,
  // },
  {
    name: "FavoriteListCount",
    icon: faThumbsUp,
    backColor: ColorEnum._red,
    color: ColorEnum.White,
    to: transferWithFavorites,
    titleFontSize: '1em',
    description: 'لیست‌هایی که مصرفی شما را موجود دارند.',
  },
  // {
  //   name: "EmploymentApplication",
  //   icon: faUserMd,
  //   backColor: ColorEnum.Purple,
  //   color: ColorEnum.White,
  //   to: jobSearchList
  // },
  {
    name: "Prescription",
    icon: faPills,
    backColor: ColorEnum._purple,
    color: ColorEnum.White,
    to: prescriptionList,
    description: 'نسخه‌های مردمی را در این قسمت مشاهده کنید و در صورت تمایل پاسخ دهید.',
  },
  // {
  //   name: "Survey",
  //   icon: faPoll,
  //   backColor: ColorEnum.Blue,
  //   color: ColorEnum.White,
  //   to: `${desktop}?state=survey`
  // }
]

export default dashboardWidgets
